module.exports = __webpack_public_path__ + "static/img/jnm-licence.3f0fdde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jnm-licence.jpg
// module id = 5ecL
// module chunks = 1